export default __webpack_public_path__ + "static/media/tablet-card.c014cef2.png";